import { apiRequest } from "../util/apiUtils";

// Larger page size = fewer round trips for users with many orders (My Books PDF map).
const PAGE_LIMIT = 100;
const MAX_PAGES = 40;

/**
 * Loads all pages of /order/order-pdfs for the authenticated user (same endpoint as My Orders).
 */
export async function fetchAllOrderPdfsForUser() {
  let all = [];
  let page = 1;
  let totalDocs = null;

  while (page <= MAX_PAGES) {
    const res = await apiRequest("get", `/order/order-pdfs`, {
      queries: { page, limit: PAGE_LIMIT },
    });

    if (!res || res.status >= 400) {
      console.error("order-pdfs request failed", res?.status);
      return page === 1 ? [] : all;
    }

    const body = res.data;
    const batch = Array.isArray(body?.data) ? body.data : [];
    const meta = body?.metadata?.[0] || {};

    if (totalDocs === null) {
      totalDocs =
        typeof meta.totalDocs === "number" ? meta.totalDocs : batch.length;
    }

    all = all.concat(batch);

    if (batch.length === 0 || all.length >= totalDocs) break;
    page += 1;
  }

  return all;
}

export function orderBookIdKey(order) {
  const raw = order?.bookId;
  if (raw == null) return null;
  if (typeof raw === "object" && raw._id != null) return String(raw._id);
  return String(raw);
}

/**
 * For each book id, keep the newest order that has consumerPdfAvailable (same flag as My Orders).
 */
export function buildBookIdToConsumerOrderMap(orders) {
  const map = new Map();
  if (!Array.isArray(orders)) return map;

  for (const order of orders) {
    if (!order?.consumerPdfAvailable) continue;
    const key = orderBookIdKey(order);
    if (!key) continue;
    const prev = map.get(key);
    if (
      !prev ||
      new Date(order.createdAt) > new Date(prev.createdAt)
    ) {
      map.set(key, order);
    }
  }
  return map;
}
